import { useEffect, useState } from "react";
import { useGetBlogsMutation } from "../../store/services/blogs";
import CustomDropdown from "../../components/CustomSelect";
import { useNavigate } from "react-router-dom";
import RebuildWebsiteButton from "../../components/RebuildWebsiteButton";

const Blogs = () => {
  const [positionOptions, setPositionOptions] = useState([]);
  const [inActivePositionOptions, setInActivePositionOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const [getBlogs, { data: blogsData, error: positionsError, isError: isPositionsFetchError, isSuccess: isBlogsFetchSuccess }] = useGetBlogsMutation();

  useEffect(() => {
    getBlogs();
  }, []);

  useEffect(() => {
    if (isBlogsFetchSuccess) {
      setPositionOptions(blogsData);
    }
  }, [isBlogsFetchSuccess, blogsData]);

  // Function to filter job posts based on the search query
  const filterPositions = (positions) => {
    return positions.filter((position) => position.page_title.toLowerCase().includes(searchQuery.toLowerCase()));
  };

  return (
    <main className="w-full bg-white flex-col flex p-10">
      <div className="filters w-full relative my-2">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Blogs</h1>

          <div className="flex gap-5">
            <RebuildWebsiteButton />

            <button onClick={() => navigate("/createBlogs")} className="px-6 py-1 bg-black rounded-md text-white text-lg uppercase">
              New Blog
            </button>
          </div>
          {/* Search bar */}
          {/* <input
            type="text"
            placeholder="Search job postings..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 mt-4"
          /> */}
        </div>

        <div className="dropdown flex-1 mt-5">
          <div className="grid grid-cols-3 w-full gap-5 mt-5">
            {filterPositions(positionOptions).map((position) => (
              <div
                key={position.page_title}
                onClick={() => navigate(`/blogs/${encodeURIComponent(position.page_slug)}`)}
                className="bg-blue-200 flex flex-col justify-between p-3 py-4 rounded-lg cursor-pointer"
              >
                {position.page_title}
                <div className="">
                  <p className="mt-3">
                    No Of Views - <span className="font-semibold"> {position.noOfClicks}</span>{" "}
                  </p>
                  <div className="flex w-full justify-between items-center align-middle ">
                    <p className="">
                      Blog ID - <span className="font-semibold"> {position.page_id}</span>{" "}
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();

                        window.open(`https://praan.io/blogs/${position.page_id}`, "_blank");
                      }}
                      className="bg-black text-white rounded px-3 py-1"
                    >
                      Open Blog
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Blogs;
